<template>
  <v-navigation-drawer color="primary" fixed app class="menu" :dark="true">
    <v-list dense nav shaped class="py-0">
      <v-list-item two-line class="px-0" @click="editProfile()">
        <v-list-item-content>
          <v-list-item-title class="title"> Instalane </v-list-item-title>
          <v-list-item-subtitle>
            {{ user.fullname }} {{ user.last_name }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item-group :value="selected_menu" class="mt-5">
        <v-list-item
          class="menu-item"
          v-for="(item, i) in list"
          :key="i"
          link
          @click="goToRoute(item, i)"
        >
          <v-list-item-icon align="center">
            <div class="icon">
              <img :src="item.icon" alt="" />
            </div>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <site-footer></site-footer>
  </v-navigation-drawer>
</template>

<script>
import route from "@/router/index";
import { mapState } from "vuex";
import SiteFooter from "@/components/layout/footer.vue";

export default {
  created() {
    this.$store.dispatch("Authenticate/me");
  },
  components: { SiteFooter },
  computed: {
    role_name() {
      return this.user && this.user.role ? this.user.role.label : "";
    },
    ...mapState({
      list: state => state.Menu.list,
      selected_menu: state => state.Menu.selected_menu,
      user: state => state.Authenticate.user
    })
  },
  methods: {
    goToRoute(item, index) {
      this.selected = index;
      route.push(item.link).catch(() => {});
    },
    editProfile() {
      this.$router.push("/admin/profile");
    }
  }
};
</script>
